const PRODUCTION_SUPABASE_REF = 'ldozrbooxvakjmoazsai';

function isNonProductionEnvironment() {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? '';
  return supabaseUrl.length > 0 && !supabaseUrl.includes(PRODUCTION_SUPABASE_REF);
}

export function DevEnvironmentBadge() {
  if (!isNonProductionEnvironment()) {
    return null;
  }

  return (
    <div
      className="fixed bottom-3 left-3 z-[9999] pointer-events-none select-none rounded-full bg-fuchsia-600 px-3 py-1 text-xs font-bold tracking-wide text-white shadow-lg"
      aria-hidden="true"
    >
      🔧 AMBIENTE DE DESARROLLO
    </div>
  );
}
